"use strict";
// Loan Application Types for LEWFIN Providers Web
// Aligned with Sky Lifestyle ILoans interface structure
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPLICATION_STATUS = exports.LOAN_TERMS_OPTIONS = exports.DEFAULT_LOAN_TERM = exports.LOAN_TERMS_VALUES = void 0;
// Loan term constants - single source of truth
exports.LOAN_TERMS_VALUES = [
    "1 MONTH",
    "2 MONTHS",
    "3 MONTHS",
    "4 MONTHS",
    "5 MONTHS",
    "6 MONTHS",
    "7 MONTHS",
    "8 MONTHS",
    "9 MONTHS",
    "10 MONTHS",
    "11 MONTHS",
    "12 MONTHS",
];
// Default loan term - single source of truth
exports.DEFAULT_LOAN_TERM = "1 MONTH";
// Loan term options for dropdowns (client restriction: 1, 3, or 5 months only)
// Data stored in uppercase to match Sky CRM, UI displays capitalized for UX
exports.LOAN_TERMS_OPTIONS = [
    { value: "1 MONTH", label: "1 Month" },
    { value: "3 MONTHS", label: "3 Months" },
    { value: "5 MONTHS", label: "5 Months" },
];
// Application status constants - aligned with Sky Lifestyle
// NOTE: SUBMITTED and PENDING both map to "AWAIT" for backward compatibility
// Use SUBMITTED for form submissions, it maps to Sky's "AWAIT" status
exports.APPLICATION_STATUS = {
    DRAFT: "DRAFT",
    SUBMITTED: "AWAIT", // When user submits application
    APPROVED: "APPROVED",
    DECLINED: "DECLINED",
    PENDING: "AWAIT", // Legacy - same as SUBMITTED
    ARCHIVED: "ARCHIVED",
    CANCELLED: "CANCELLED",
};
